import { useEffect, useRef, useState } from 'react';
import GraphIcon from '../../../../assets/svg/viewership/graph.svg';
import TableIcon from '../../../../assets/svg/viewership/table.svg';
import Tooltip from "../../../../component/Tooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

export const DropDownFilters = (props) => {
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState("IN");
    const [selectedDistribution, setSelectedDistribution] = useState("");
    const [selectedDuration, setSelectedDuration] = useState("Last 7 days");
    const [selectedMetric, setSelectedMetric] = useState("SESSION");
    const [selectedTimePeriod, setSelectedTimePeriod] = useState('HOUR');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef();
    const [calenderStartDate, setCalenderStartDate] = useState(null);
    const [calenderEndDate, setCalenderEndDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const nowDate = new Date();
    const initToday = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());
    let initStartDate = new Date(initToday);
    initStartDate.setDate(initStartDate.getDate() - 7);
    let initEndDate = new Date(initToday - 1); 
    const [dateRange, setDateRange] = useState({
        startEpoch: initStartDate?.getTime() || null,
        endEpoch: initEndDate?.getTime() || null,
    });

    const calculateEpochRange = (duration, customStart, customEnd) => {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // today 12AM (local)

        let startDate = null;
        let endDate = null;

        switch (duration) {
            case "Today":
                startDate = new Date(today); // today 12AM
                endDate = new Date();        // current time
                break;

            case "Yesterday":
                startDate = new Date(today);
                startDate.setDate(startDate.getDate() - 1); // 1 days ago 12AM
                endDate = new Date(today - 1);                  // today 11:59PM
                break;

            case "Last 7 days":
                startDate = new Date(today);
                startDate.setDate(startDate.getDate() - 7); // 7 days ago 12AM
                endDate = new Date(today - 1);                  // today 11:59PM
                break;

            case "This month":
                startDate = new Date(now.getFullYear(), now.getMonth(), 1); // 1st of this month at 12AM
                endDate = new Date();                                   // today 12AM
                break;

            case "Last month":
                const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1); // 1st of last month
                const firstDayThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);     // 1st of this month
                startDate = new Date(firstDayLastMonth);
                endDate = new Date(firstDayThisMonth - 1); // end = last month 30/31st 11:59PM
                break;
            case "Custom":
                startDate = new Date(customStart);
                endDate = new Date(customEnd);
                endDate.setHours(23, 59, 59, 0);
                break;
            default:
                break;
            }
        return {
            startEpoch: startDate?.getTime() || null,
            endEpoch: endDate?.getTime() || null,
        };
    };

    

    useEffect(() => {
        const tenantId = JSON.parse(localStorage.getItem("tenantInfo")).code;
        let payload = {};
        const channelsJoined = selectedChannels.join(',').toLowerCase();
        if (props?.isActive === "table") {
            payload = {
                channels: channelsJoined,
                startAt: dateRange?.startEpoch,
                endAt: dateRange?.endEpoch,
                sortBy: "total_duration",
                countryFilter: selectedTerritory,
                distributionPlatform: selectedDistribution,
                tenant: tenantId,
            }
        } else {
            payload = {
                channels: channelsJoined,
                metricType: selectedMetric,
                interval: selectedTimePeriod,
                startAt: dateRange?.startEpoch,
                endAt: dateRange?.endEpoch,
                countryFilter: selectedTerritory,
                distributionPlatform: selectedDistribution,
                tenant: tenantId,
            }
        }
        props.viewershipDataFunc(payload);
    }, [selectedChannels, selectedTerritory, selectedDistribution, selectedDuration, selectedMetric, selectedTimePeriod, dateRange])

    useEffect(() => {
        // if (props?.isActive !== "table") {
        const filteredChannels = props?.allChannelsListColl?.filter((channel) =>
            props?.distributionPlatform?.some((item) => item.channelCode.toUpperCase() === channel.channelId)
        );
        const channelIds = filteredChannels?.map(item => item.channelId.toLowerCase());
        setSelectedChannels(channelIds.map(id => id.toUpperCase()));
        // }
    }, [props.isActive]);

    const onSelectDistribution = (e) => {
        if (props?.isActive === "table") {
            if (e === "") {
                const filteredChannels = props?.allChannelsListColl?.filter((channel) =>
                    props?.distributionPlatform?.some((item) => item.channelCode.toUpperCase() === channel.channelId)
                );
                props?.setAllchannelslist(filteredChannels);
                const channelIds = filteredChannels.map(item => item.channelId.toLowerCase());
                setSelectedChannels(channelIds.map(id => id.toUpperCase()))
            } else {
                const matchedDistributions = props?.distributionPlatform?.filter(item => item.distributionPlatforms === e);
                const filteredChannels = props?.allChannelsListColl?.filter((channel) =>
                    matchedDistributions?.some((item) => item.channelCode.toUpperCase() === channel.channelId)
                );
                props?.setAllchannelslist(filteredChannels);
                const channelIds = filteredChannels.map(item => item.channelId.toLowerCase());
                setSelectedChannels(channelIds.map(id => id.toUpperCase()))
            }
        } else {
            if (e === "") {
                const filteredChannels = props?.allChannelsListColl?.filter((channel) =>
                    props?.distributionPlatform?.some((item) => item.channelCode.toUpperCase() === channel.channelId)
                );
                props?.setAllchannelslist(filteredChannels);
                const channelIds = filteredChannels.map(item => item.channelId.toLowerCase());
                setSelectedChannels(channelIds.map(id => id.toUpperCase()))
            } else {
                const matchedDistributions = props?.distributionPlatform?.filter(item => item.distributionPlatforms === e);
                const filteredChannels = props?.allChannelsListColl?.filter((channel) =>
                    matchedDistributions?.some((item) => item.channelCode.toUpperCase() === channel.channelId)
                );
                props?.setAllchannelslist(filteredChannels);
                const channelIds = filteredChannels.map(item => item.channelId.toLowerCase());
                setSelectedChannels(channelIds.map(id => id.toUpperCase()))
            }
        }
    }

    const formatDate = (epoch) => {
        if (!epoch) return "-";
        const date = new Date(epoch);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleChannelCheckbox = (channelId) => {
        setSelectedChannels(prev =>
            prev.includes(channelId)
                ? prev.filter(id => id !== channelId)
                : [...prev, channelId]
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleDurationChange = (value, customStart, customEnd) => {
        setSelectedDuration(value);
        const { startEpoch, endEpoch } =
            value === "Custom"
            ? calculateEpochRange(value, customStart, customEnd)
            : calculateEpochRange(value);

        setDateRange({ startEpoch, endEpoch });
        if (value !== "Custom") setShowDatePicker(false);
    };
    return (
        <>
            <div className="row">
                <div className="col-11">
                    <div className="row drop-down-filters">
                        <div className="col-2">
                            <label className="d-block">All Platform</label>
                            <select
                                className="rounded select-grid-header m-0"
                                defaultValue={selectedDistribution}
                                onChange={(e) => {
                                    setSelectedDistribution(e.target.value);
                                    onSelectDistribution(e.target.value);
                                }}
                            >
                                <option value="">All</option>
                                {
                                    [...new Set(props?.distributionPlatform?.map(data => data?.distributionPlatforms))]
                                        .map((platform, index) => (
                                            <option key={index} value={platform}>{platform}</option>
                                        ))
                                }

                            </select>
                        </div>
                        <div className="col-2" ref={dropdownRef}>
                            <label className="d-block">Channels</label>
                            <div
                                className="multi-selector rounded select-grid-header m-0"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                            >
                                {selectedChannels.length === 0 ? (
                                    "ALL CHANNELS"
                                ) : selectedChannels.length === props?.allChannelsList?.length ? (
                                    "ALL CHANNELS"
                                ) : selectedChannels.length === 1 ? (
                                    props?.allChannelsList?.find(
                                    (c) => c.channelId === selectedChannels[0]
                                    )?.name
                                ) : (
                                <>
                                    {props?.allChannelsList?.find(c => c.channelId === selectedChannels[0])?.name}
                                    <span
                                    style={{
                                        backgroundColor: "#404040",
                                        color: "#fff",
                                        padding: "0px 6px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        marginLeft: "4px",
                                        display: "inline-block",
                                        minWidth: "22px",
                                        textAlign: "center"
                                    }}
                                    >
                                    +{selectedChannels.length - 1}
                                    </span>
                                </>
                                )}
                            </div>
                            {dropdownOpen && (
                                <div
                                    className="mt-1 position-absolute p-2"
                                    style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto", width: "200px", backgroundColor: "#444648", border: "1px solid #404040" }}
                                >
                                    {props?.allChannelsList?.map((channel) => (
                                        <div key={channel.id} className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={channel.channelId}
                                                checked={selectedChannels.includes(channel.channelId)}
                                                onChange={() => handleChannelCheckbox(channel.channelId)}
                                            />
                                            <label className="form-check-label" htmlFor={channel.channelId}>
                                                {channel.name}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="col-2">
                            <label className="d-block">Location</label>
                            <select
                                className="rounded select-grid-header m-0"
                                value={selectedTerritory}
                                onChange={(e) => setSelectedTerritory(e.target.value)}
                            >
                                {
                                    props?.territorys?.map((data) => {
                                        return <option value={data?.iso}>{data?.name}</option>
                                    })
                                }
                            </select>
                        </div>
                        {/* <div className="col-2">
                            <label className="d-block">Duration</label>
                            <select
                                className="rounded select-grid-header m-0"
                                defaultValue={selectedDuration}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedDuration(value);
                                    const { startEpoch, endEpoch } = calculateEpochRange(value);
                                    setDateRange({ startEpoch, endEpoch });
                                }}
                            >
                                {
                                    ["Today", "Yesterday", "Last 7 days", "This month", "Last month"].map((data) => {
                                        return <option value={data}>{data}</option>
                                    })
                                }
                            </select>
                        </div> */}
                        <div className="col-2 position-relative">
                            <label className="d-block">Duration</label>
                            <select
                                className="rounded select-grid-header m-0"
                                value={selectedDuration}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "Custom") {
                                        setSelectedDuration("Custom");
                                        setShowDatePicker(true);
                                    } else {
                                        setSelectedDuration(value);
                                        handleDurationChange(value);
                                    }
                                }}
                            >
                                {/* hidden placeholder for reset case */}
                                <option value="" disabled hidden>
                                    Custom 📅
                                </option>
                                {["Today", "Yesterday", "Last 7 days", "This month", "Last month"].map((data) => (
                                <option key={data} value={data}>
                                    {data}
                                </option>
                                ))}
                                <option value="Custom">Custom 📅</option>
                            </select>

                            {showDatePicker && selectedDuration === "Custom" && (
                                <div
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    zIndex: 2000,
                                }}
                                >
                                <DatePicker
                                    selected={calenderStartDate}
                                    onChange={(dates) => {
                                    setCalenderStartDate(dates[0]);
                                    setCalenderEndDate(dates[1]);

                                    if (dates[0] && dates[1]) {
                                        const startEpoch = dates[0].getTime();
                                        const endEpoch = dates[1].getTime();
                                        setDateRange({ startEpoch, endEpoch });
                                        handleDurationChange("Custom", startEpoch, endEpoch);
                                        setShowDatePicker(false);
                                        setSelectedDuration("");
                                    }
                                    }}
                                    startDate={calenderStartDate}
                                    endDate={calenderEndDate}
                                    selectsRange
                                    shouldCloseOnSelect={true}
                                    open
                                    onClickOutside={() => setShowDatePicker(false)}
                                />
                                </div>
                            )}
                        </div>
                        <div className="col-3">
                            <label className="d-block">Showing for dates</label>
                            <p className="py-1 px-2 rounded text-center">{formatDate(props?.dateRange.startEpoch)} - {formatDate(props.dateRange.endEpoch)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-1 my-auto ps-0 pe-2">
                    <div className="bottomNevigateView" >
                        <span
                            className={props?.isActive === "graph" ? "active" : ""}
                            onClick={() => props?.setIsActive("graph")}
                        >
                            <Tooltip text="Graph Section" placement="bottom">
                                <img src={GraphIcon} alt="Graph Icon" />
                            </Tooltip>
                        </span>
                        <span
                            className={props?.isActive === "table" ? "active" : ""}
                            onClick={() => props?.setIsActive("table")}
                        >
                            <Tooltip text="Table Section" placement="bottom">
                                <img src={TableIcon} alt="Table Icon" />
                            </Tooltip>
                        </span>
                    </div>
                </div>
            </div>
            {
                props?.isActive === "graph" &&
                <>
                    <div className="row mt-2">
                        <div className="col-4">
                            <div className="line-chart-filters btn-radio-group d-flex gap-2">
                                {["SESSION", "VIEWER", "WATCH_TIME"].map((item) => (
                                    <label key={item} className={selectedMetric === item ? "selected" : ""}>
                                        <input
                                            type="radio"
                                            name="metric"
                                            value={item}
                                            checked={selectedMetric === item}
                                            onChange={() => setSelectedMetric(item)}
                                        />
                                        <span className="btn rounded border">{item === "WATCH_TIME" ? "WATCH TIME" : item.charAt(0) + item.slice(1)}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div className="col-3 text-center">
                            <div class="line-chart-filters btn-radio-group d-flex gap-2 justify-content-center">
                                {["HOUR", "DAY"].map((item) => (
                                    <label key={item} className={selectedTimePeriod === item ? "selected" : ""}>
                                    <input
                                        type="radio"
                                        name="timeType"
                                        id={item}
                                        value={item}
                                        checked={selectedTimePeriod === item}
                                        onChange={() => setSelectedTimePeriod(item)}
                                        autoComplete="off"
                                    />
                                        <span className="btn rounded border" htmlFor={item}>
                                            {item}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div className="col-5 ms-auto">
                            <div className="line-chart-filters btn-radio-group d-flex gap-2 justify-content-end">
                                {["line", "bar", "pie"].map((item) => (
                                    <label
                                        key={item}
                                        className={props?.chartViewType === item ? "selected" : ""}
                                    >
                                        <input
                                            type="radio"
                                            name="metric"
                                            value={item}
                                            checked={props?.chartViewType === item}
                                            onChange={() => props.setChartViewType(item)}
                                        />
                                        <span className="btn rounded border">
                                            {item === "line" ? "LINE CHART" : item === "bar" ? "COLUMN CHART" : "PIE CHART"}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 text-white">
                        <div className="col-2">
                            <div className="graph-info d-flex justify-content-between align-items-center p-2">
                                <span className="w-50 graph-info-title">Total <br /> Sessions</span>
                                <span>501</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="graph-info d-flex justify-content-between align-items-center p-2">
                                <span className="w-50 graph-info-title">Total Watch <br /> Time</span>
                                <span>14:47:49</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="graph-info d-flex justify-content-between align-items-center p-2">
                                <span className="w-50 graph-info-title">Avg Watch time <br /> (per user)</span>
                                <span>14:47:49</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="graph-info d-flex justify-content-between align-items-center p-2">
                                <span className="w-50 graph-info-title">Avg Watch time <br /> (per Session)</span>
                                <span>21:18:25</span>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
} 